import React, {  memo, useLayoutEffect } from "react";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";
import { VaporHorizontalStepper, VaporDatePicker } from "../../../../vapor";
import { useIntl } from "react-intl";
import moment from "moment";
import ContainerWithVerticalLine from "./containerWithVerticalLine";
import NumberFormat from "react-number-format";

const RemovalSubSectionPage1 = ({state, fields, setFields,  removalState, setRemovalState}) => {
  const intl = useIntl();
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  
  useLayoutEffect(()=>{
    if (!document.querySelector(".vapor-drawer-container.ps.ps--active-y")) return;
    document.querySelector(".vapor-drawer-container.ps.ps--active-y").scrollTo(0,0);
  },[]);

  const steps = [
    {
      number: 1,
      title: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.eliminationData"}),
      clickable: false
    },
    {
      number: 2,
      title: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.previewAccount"}),
      clickable: false
    }
  ];
  
  return (
    <>
      <VaporHorizontalStepper 
        currentStep={1}
        steps={steps}
        readOnly={false}
      />
      <ContainerWithVerticalLine
        topLeft={
          <div>
            <div className="pre-cog-assets-drawer-conto-amount"> {numeral(state.totalAmount).format("0,0.00")} € </div>
            <div className="pre-cog-assets-drawer-subtitles"> <FormattedMessage id="preCog.assetsTab.drawer.existingAssetValue" /> </div>
          </div>      
        }
        bottomLeft={
          <div style={{ marginTop: "40px" }}>
            <div className="pre-cog-assets-drawer-conto-amount"> {numeral(state.totalResidualAmount).format("0,0.00")} € </div>
            <div className="pre-cog-assets-drawer-subtitles" > <FormattedMessage id="preCog.assetsTab.drawer.residualAt" /> {state.residualReferenceDate}</div>
          </div>
        }
        topRight={
          <div style={{paddingTop: "30px"}}>
            <div className="pre-cog-assets-drawer-subtitles"> <FormattedMessage id="preCog.assetsTab.drawer.activationDate2" /> {state.activationDate}</div>
          </div>
        }
        bottomRight={
          <div>
            <div className="precog-withholding-drawer-form—label-text" style={{ paddingTop: "30px" }}> 
              <FormattedMessage id="preCog.assetsTab.drawer.buttons.delete" /> &nbsp; *</div>
            <VaporDatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              className='pre-cog-assets-drawer-revaluation-field'
              style={{ width: "220px" }}
              format={dateFormatList}
              value={fields.date ? moment(fields.date, dateFormatList[0]) : null}
              onChange={(e) =>  {
                setFields(prev => ({ ...prev, date: e }));
              }}
            />
          </div>
        }
      />
      <ContainerWithVerticalLine
        style={{marginTop: "30px"}}
        topLeft={
          <div>
            <div className="pre-cog-assets-drawer-conto-amount"> 
              {numeral(fields.saleAmount).format("0,0.00")} € 
            </div>
            <div className="pre-cog-assets-drawer-subtitles"> 
              <FormattedMessage id="preCog.assetsTab.drawer.movements.taxLoss" />
            </div>
          </div>      
        }
        bottomLeft={
          <div style={{ marginTop: "40px" }}>
            <div className="pre-cog-assets-drawer-conto-amount"> {numeral(removalState.civilisticCapitalLoss).format("0,0.00")} € </div>
            <div className="pre-cog-assets-drawer-subtitles" > 
              <FormattedMessage id="preCog.assetsTab.drawer.movements.civilLoss" />
            </div>
          </div>
        }
        topRight={
          <div></div>
        }
        bottomRight={
          <div>
            <div className="precog-withholding-drawer-form—label-text"> 
              <FormattedMessage id="preCog.assetsTab.drawer.movements.deletePercentage" /> &nbsp; *</div>
            <NumberFormat
              style={{width: "220px"}}
              displayType={"input"}
              valueIsNumericString={true}
              decimalScale={2}
              // allowEmptyFormatting={false}
              // allowLeadingZeros={true}
              allowNegative={false}
              thousandSeparator={"."}
              decimalSeparator={","}              
              className="inputCustom drawer-inputCustom "
              placeholder="-"
              suffix={"%"}              
              value={fields?.disposalRate && fields?.disposalRate !== 0 ? numeral(fields.disposalRate).format("0,0.00") : null}
              onValueChange={(el) => {      
                setFields(prev => ({ ...prev, disposalRate: (el.floatValue > 100 ? 100 : el.floatValue || null) }));                                                             
              }        
              }                                    
            />          
          </div>
        }
      />
    </>
  );
};

export default memo(RemovalSubSectionPage1);
